<form
  (ngSubmit)="handleSubmitClick()"
  [formGroup]="form">
  <app-form-control label="Nazwa">
    <input
      [formControl]="form.controls.name"
      appPrimengInputText
      pInputText
      placeholder="Wprowadź opis" />
  </app-form-control>

  <app-form-control label="Kategoria">
    <input
      [formControl]="form.controls.category"
      appPrimengInputText
      pInputText
      placeholder="Wprowadź kategorię" />
  </app-form-control>

  <app-form-control label="Opis">
    <app-summernote
      [formControl]="form.controls.description"
      [uploadFn]="uploadFn" />
  </app-form-control>

  <div class="rounded-lg border border-gray-200 p-4">
    <p-accordion
      [multiple]="true"
      [value]="activePriceIndex">
      @for (
        priceFormGroup of getPriceFormGroups();
        track priceFormGroup;
        let index = $index, count = $count
      ) {
        <app-admin-shipping-method-form-price-panel
          [index]="index"
          [priceFormGroup]="priceFormGroup"
          (removeClickEvent)="handlePriceRemoveClick(index)"
          [total]="count" />
      }
    </p-accordion>

    <div class="mt-4 flex justify-end">
      <p-button
        (onClick)="handleProductAddClick()"
        appPrimengButton
        label="Dodaj kraj wysyłki" />
    </div>
  </div>

  <div class="mt-4 flex justify-end">
    <p-button
      [disabled]="form.invalid"
      appPrimengButton
      label="Zapisz"
      severity="primary"
      type="submit" />
  </div>
</form>
